import React from 'react'
import { AuthLayout } from '@/components/Layouts'
import {
  EmailVerification,
  ForgotPassword,
  Login,
  Register,
  ResetPassword,
} from '@/features/auth/routes'
import { LandingRoot } from '@/features/landing/routes'
import { AuthGuard } from '@/routes/components'
import { PATH } from '@/routes/const'

//config
export const getAuthRoutes = (isLoggedIn: boolean) => {
  return [
    {
      element: <AuthGuard isLoggedIn={isLoggedIn} />,
      children: [
        {
          index: !isLoggedIn,
          path: '/*',
          element: <LandingRoot />,
        },
        {
          element: <AuthLayout />,
          children: [
            {
              path: PATH.LOGIN,
              element: <Login />,
            },
            {
              path: PATH.REGISTER,
              element: <Register />,
            },
            {
              path: PATH.EMAIL_VERIFICATION,
              element: <EmailVerification />,
            },
            {
              path: PATH.FORGOT_PASSWORD,
              element: <ForgotPassword />,
            },
            {
              path: `${PATH.RESET_PASSWORD}`,
              element: <ResetPassword />,
            },
          ],
        },
      ],
    },
  ]
}
